import React from 'react';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { SettingsCoordinator } from '~settings-coordinator/SettingsCoordinator';

import { getSessionManagementServiceInstance } from '../../../../sessionManagement/SessionManagementService';
import { LimitedAccessBanner } from '../../../components/LimitedAccessBanner';
import { GeneralSiteSettingsSubspaceState } from '../../../components/subspaces/SiteSettingsSpace/GeneralSiteSettingsSubspace';
import { coordinatorSubmitFailedHandler, coordinatorSubmitHandler } from '../common/GeneralToastHandlers';
import { ReactMetadataDrivenSiteSettings } from './ReactMetadataDrivenSiteSettingsSubFormik';
import ReactSiteSettingsForServerAdmin from './ReactSiteSettingsForServerAdminSubFormik';
import { ReactSiteSettingsForSiteAdmin } from './ReactSiteSettingsForSiteAdminSubFormik';

/**
 * Creates a settings coordinator with the site settings for site admin and site settings for server admin forms
 */
export function GeneralSiteSettingsCoordinator(props: GeneralSiteSettingsSubspaceState) {
  const sessionManagementService = getSessionManagementServiceInstance();

  const shouldRenderServerAdminForm = sessionManagementService.isSessionServerAdmin();
  const shouldRenderSiteAdminForm = sessionManagementService.isSessionServerAdmin()
    || (sessionManagementService.isSessionSiteAdmin() && sessionManagementService.isOnlineEnvironment());

  // Admin Profile users reach this coordinator only when the dedicated feature
  // flag is on AND the route guard let them in (i.e. the backend reported they
  // have settings access). When off, they're blocked at the route guard and
  // never render here, so we simply don't render the metadata-driven form.
  const shouldRenderSiteAdminFormForAdminProfile =
    FeatureFlags.adminProfilesForSiteSettingsEnabled
    && !shouldRenderServerAdminForm
    && !shouldRenderSiteAdminForm;

  return (
    <>
      {shouldRenderSiteAdminFormForAdminProfile && <LimitedAccessBanner />}
      <SettingsCoordinator
        onSubmit={coordinatorSubmitHandler}
        onSubmitFailure={coordinatorSubmitFailedHandler}
        submitSequentially = {true}>

        {shouldRenderServerAdminForm &&
        <ReactSiteSettingsForServerAdmin settings={props}/>}

        {shouldRenderSiteAdminForm &&
        <ReactSiteSettingsForSiteAdmin settings={props}/>}

        {shouldRenderSiteAdminFormForAdminProfile &&
        <ReactMetadataDrivenSiteSettings settings={props}/>}

      </SettingsCoordinator>
    </>
  );
}
